export default "__VITE_ASSET__DLHDGC2G__"